export default __webpack_public_path__ + "static/media/techhelp.8012746c.png";